import React, { useState } from "react"
import { ApolloProvider } from "@apollo/client"
import { client } from "./config/aplloClient"
import { BrowserRouter } from "react-router-dom"
import MainRouter from "./router"
import { SmartFarmProvider } from "./context/SmartFarmContext"
import LoginForm from "./components/LoginForm"

const App: React.FC = () => {
  const [accessToken, setAccessToken] = useState<string | null>(
    localStorage.getItem("accessToken")
  )
  const [refreshToken, setRefreshToken] = useState<string | null>(
    localStorage.getItem("refreshToken")
  )

  const handleLogin = (newAccessToken: string, newRefreshToken: string) => {
    setAccessToken(newAccessToken)
    setRefreshToken(newRefreshToken)
    localStorage.setItem("accessToken", newAccessToken)
    localStorage.setItem("refreshToken", newRefreshToken)
  }

  const handleLogout = () => {
    setAccessToken(null)
    setRefreshToken(null)
    localStorage.removeItem("accessToken")
    localStorage.removeItem("refreshToken")
  }

  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        {accessToken ? <MainRouter /> : <LoginForm onLogin={handleLogin} />}
      </BrowserRouter>
    </ApolloProvider>
  )
}

export default App
